// main.js — the global CSS, then the one bootstrap call. Everything the app boots with (routes,
// store, strings, Vuetify options, the locale source) is ./dashboard.config.js; createDashboard
// (@rdrive/plugin-dashboard-shell) creates and installs router → Vuetify → store → i18n and
// returns the app (IA_ABSORPTION_PLAN Phase 1 step 6b-2a).
// The CSS stays here, first: it is bundle-level, and its import order is the cascade order.
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.min.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

import { createDashboard } from '@rdrive/plugin-dashboard-shell';
import dashboardConfig from './dashboard.config.js';

createDashboard(dashboardConfig).mount('#app');
